import type { Widen } from '../catalogue';
import type { svShell } from '../sv/shell';

export const enShell: Widen<typeof svShell> = {
  brandAlt: 'brand',
  pages: {
    somethingWentWrong: 'Something went wrong',
    notFound: '404: Page not found',
    goHome: 'Go to the home page'
  },
  loadingPage: {
    text: 'Loading…'
  },
  appShell: {
    openMenu: 'Open menu',
    generateCameraLink: 'Generate camera link',
    settings: 'Settings',
    projects: 'Projects',
    drawings: 'Drawings',
    logout: 'Log out',
    somethingWentWrong: 'Something went wrong.',
    media: 'Media',
    places: 'Main menu',
    accountMenu: 'Account menu for {{name}}'
  },
  linkModal: {
    title: 'Camera links',
    validFor: 'The following link will be valid for 12 hours.',
    afterExpiry: "To access this organisation's camera after the link expires, a new link will need to be generated.",
    tempLink: 'Temporary link:',
    permaLink: 'Permanent link:',
    replaceWarning:
      'The current permanent link and its printed QR codes will stop working at once. Create a new permanent link?',
    revokeAndCreate: 'Revoke and create new',
    replaced: 'Permanent link replaced',
    replaceFailed: 'Could not replace the permanent link.',
    urlCopied: 'Url copied to clipboard!',
    copyTemp: 'Copy temporary link',
    copyPerma: 'Copy permanent link',
    printTemp: 'Print temporary link QR code',
    printPerma: 'Print permanent link QR code',
    revokePerma: 'Revoke permanent link'
  },
  globalState: {
    wrongPassword: 'Wrong password!',
    userNotFound: 'User not found!',
    signOutFailed: 'Failed to sign out!'
  },
  homePage: {
    swapToMap: 'Swap to map view',
    swapToList: 'Swap to list view',
    closeFilters: 'Close filters',
    filters: 'Filters',
    filtersCount: 'Filters · {{count}}',
    countAll_one: '{{count}} report',
    countAll_other: '{{count}} reports',
    countShown_one: '{{shown}} of {{count}} report',
    countShown_other: '{{shown}} of {{count}} reports'
  },
  map: {
    loadError: 'Ooops! There was an error when loading the map. Please refresh the page to try again.',
    drawingMarker: 'Drawing: {{name}}',
    loading: 'Loading map'
  },
  location: {
    noPosition: 'No position',
    approximate: 'Approximate position ({{accuracy}})'
  },
  sortableTable: {
    noData: 'No data',
    actions: 'Actions',
    cameraLink: 'Camera link',
    view: 'View',
    restore: 'Restore',
    changeAccountStatus: 'Change account status',
    resendActivation: 'Send the activation link again'
  },
  statusDropdown: {
    none: 'There are no statuses.'
  },
  mapDataList: {
    unknownOrganisation: 'Internal error! Unknown organisation',
    somethingWentWrong: 'Something went wrong. Please try again later. Error: {{error}}',
    emailSubject: 'Download link, EVID',
    markReadFailed: 'Could not mark the media item as read.',
    markUnreadFailed: 'Could not mark the media item as unread.',
    adminComment: 'Admin comment',
    statusName: 'Status name',
    projectName: 'Project name',
    assigneeName: 'Assignee name',
    photo: 'Photo',
    video: 'Video',
    noMessage: 'No message provided',
    markAsRead: 'Mark as read',
    markAsUnread: 'Mark as unread',
    read: 'Read',
    unread: 'Unread',
    downloadPdfTitle: 'Download a PDF report with this photo, comments, and details',
    downloading: 'Downloading…',
    downloadPdf: 'Download PDF report',
    downloadImageAs: 'Download the photo as',
    downloadJpegTitle: 'Download the original photo as a JPEG file',
    downloadPngTitle: 'Download the original photo as a PNG file',
    jpeg: 'JPEG',
    png: 'PNG',
    pdf: 'PDF',
    downloadVideo: 'Download video',
    sendImage: 'Send image in email',
    sendVideo: 'Send video in email',
    loadingData: 'Loading data',
    noReports: 'No reports to show',
    markCheckedReadTitle: 'Mark all checked reports as read',
    markCheckedUnreadTitle: 'Mark all checked reports as unread',
    markCheckedRead: 'Change marked items to read',
    markCheckedUnread: 'Change marked items to unread',
    uncheckAllTitle: 'Uncheck all reports in the list',
    checkAllTitle: 'Check every report in the list',
    unselectAll: 'Unselect all',
    selectAll: 'Select all',
    onlyProjectsWithItems: 'Only projects containing items are shown. <link>Click here</link> for all projects',
    projectLabel: 'Project name:',
    statusLabel: 'Status:',
    noFiles: 'No files!',
    new: 'New',
    selectItem: 'Select the media item',
    reportFailed: 'Could not create the PDF report.',
    open: 'Open',
    comment: 'Comment',
    download: 'Download',
    moreActions: 'More actions'
  },
  deleteModal: {
    title: 'Delete the media item?',
    confirm: 'The media item and its photo or video are deleted for everyone.',
    bothRemoved: 'This cannot be undone.',
    confirmButton: 'Delete the media item',
    deleted: 'Media item deleted'
  },
  commentModal: {
    title: 'Internal comment',
    saved: 'Comment saved',
    saveFailed: 'Could not save the comment.'
  }
};
